// src/components/Header.js

import React from "react";
import { useNavigate } from "react-router-dom";
import { useLanguage } from "../context/LanguageContext";
import translations from "../data/translations";

const LANGS = [
  { code: "English",    label: "English"    },
  { code: "Roman Urdu", label: "Roman Urdu" },
];

const Header = ({ showBack = false, onBack }) => {
  const { language, setLanguage } = useLanguage();
  const navigate = useNavigate();
  const t = translations[language] || translations["Roman Urdu"];

  const handleBack = () => {
    if (onBack) onBack();
    else navigate(-1);
  };

  return (
    <header className="bg-white" style={{ borderBottom: "1px solid #eef0f3" }}>
      <div className="d-flex justify-content-between align-items-center py-3 px-3 px-md-4"
        style={{ maxWidth: "1200px", margin: "0 auto" }}>

        <div className="d-flex align-items-center gap-3">
          {showBack && (
            <button onClick={handleBack}
              style={{ background: "none", border: "none", padding: "4px 8px", cursor: "pointer", color: "#0099CC", fontSize: "0.9rem", fontWeight: 600, display: "flex", alignItems: "center", gap: "4px" }}>
              {t.backBtn}
            </button>
          )}
          <h3 className="m-0 fw-bold"
            style={{ fontSize: "1.4rem", cursor: "pointer", color: "#1a1a2e" }}
            onClick={() => navigate("/")}>
            WEB<span style={{ color: "#00B7E8" }}>DOC</span>
          </h3>
        </div>

        <div className="d-flex align-items-center rounded-pill px-1 py-1"
          style={{ border: "1.5px solid #e6eef3", gap: "2px", background: "#fafafa" }}>
          {LANGS.map((lang) => {
            const isActive = language === lang.code;
            return (
              <button key={lang.code} onClick={() => setLanguage(lang.code)}
                style={{ border: "none", borderRadius: "20px", padding: "5px 16px", fontSize: "0.78rem", fontWeight: isActive ? 700 : 400, cursor: "pointer", background: isActive ? "#0099CC" : "transparent", color: isActive ? "#fff" : "#666", transition: "all 0.2s", whiteSpace: "nowrap" }}>
                {lang.label}
              </button>
            );
          })}
        </div>
      </div>
    </header>
  );
};

export default Header;